import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  constructor(private http: HttpClient) {}

  public GetClientes(): Observable<any> {
    const url = `${environment.baseURL}Cliente/GetClientes`;
    return this.http.get<any>(url);
  }
}
